const en = {
  brandTitle: "Vehicle Fitment Form",
  steps: { address: "Address", vehicle: "Vehicle & Part", review: "Review" },
  step1Title: "Step 1: Address",
  step2Title: "Step 2: Vehicle & Part",
  step3Title: "Step 3: Review & Confirm",
  footerPrivacyNotice: "Notes: You are no longer on Costco's site and are subject to the privacy policy of the company hosting this site.",
  footerPrivacyLink: "Review the privacy policy.",
  field: {
    name: "Full name",
    email: "Email",
    phone: "Phone",
    street: "Street address",
    city: "City",
    province: "Province/State",
    postal: "Postal/ZIP code",
    year: "Year",
    make: "Make",
    model: "Model",
    submodel: "Submodel",
    productType: "Product Type",
    partNumber: "Part Number",
    fitmentNotes: "Fitment Notes",
    availability: "Availability"
  },
  req: " *",
  btn: {
    next: "Next",
    review: "Review & Confirm",
    editVehicle: "Edit Vehicle/Part",
    confirm: "Confirm & Continue",
    top: "Back to top"
  },
  alerts: {
    saveAddressFail: "We couldn’t save your address. Please try again.",
    recordSelectionFail: "We couldn’t record your selection. Please try again.",
    loadYearsFail: "Failed to load years.",
    loadMakesFail: "Failed to load makes.",
    loadModelsFail: "Failed to load models.",
    loadSubmodelsFail: "Failed to load submodels.",
    loadPartsFail: "Failed to load parts.",
    selectPart: "Please select a part to continue."
  },
  status: {
    savingAddress: "Saving address…",
    loadingOptions: "Loading options…",
    submitting: "Submitting…"
  },
  parts: {
    heading: "Available parts",
    none: "No parts found for this selection.",
    tableCaption: "List of parts for the chosen vehicle",
    select: "Select"
  },
  sections: { address: "Address", vehicle: "Vehicle", chosenPart: "Chosen Part" },
  footer: "© UGuard Automotive / UGuard Overland",
  skipToMain: "Skip to main content",
  language: "Language",
  english: "English",
  french: "Français"
};

const fr = {
  brandTitle: "Informations sur le véhicule",
  steps: { address: "Adresse", vehicle: "Véhicule & pièce", review: "Relecture" },
  step1Title: "Étape 1 : Adresse",
  step2Title: "Étape 2 : Véhicule & pièce",
  step3Title: "Étape 3 : Vérifier & confirmer",
  footerPrivacyNotice:"Remarque : Vous n’êtes plus sur le site de Costco et êtes assujetti à la politique de confidentialité de l’entreprise qui héberge ce site.",
  footerPrivacyLink: "Consulter la politique de confidentialité.",
  field: {
    name: "Nom complet",
    email: "Courriel",
    phone: "Téléphone",
    street: "Adresse",
    city: "Ville",
    province: "Province/État",
    postal: "Code postal/ZIP",
    year: "Année",
    make: "Marque",
    model: "Modèle",
    submodel: "Sous-modèle",
    productType: "Type de produit",
    fitmentNotes: "Remarques d’ajustement",
    partNumber: "Numéro de pièce",
    availability: "Disponibilité"
  },
  req: " *",
  btn: {
    next: "Suivant",
    review: "Vérifier & confirmer",
    editVehicle: "Modifier véhicule/pièce",
    confirm: "Confirmer & continuer",
    top: "Haut de page"
  },
  alerts: {
    saveAddressFail: "Impossible d’enregistrer votre adresse. Veuillez réessayer.",
    recordSelectionFail: "Impossible d’enregistrer votre sélection. Veuillez réessayer.",
    loadYearsFail: "Échec du chargement des années.",
    loadMakesFail: "Échec du chargement des marques.",
    loadModelsFail: "Échec du chargement des modèles.",
    loadSubmodelsFail: "Échec du chargement des sous-modèles.",
    loadPartsFail: "Échec du chargement des pièces.",
    selectPart: "Veuillez choisir une pièce pour continuer."
  },
  status: {
    savingAddress: "Enregistrement de l’adresse…",
    loadingOptions: "Chargement…",
    submitting: "Envoi…"
  },
  parts: {
    heading: "Pièces disponibles",
    none: "Aucune pièce trouvée pour cette sélection.",
    tableCaption: "Liste des pièces pour le véhicule choisi",
    select: "Choisir"
  },
  sections: { address: "Adresse", vehicle: "Véhicule", chosenPart: "Pièce choisie" },
  footer: "© UGuard Automotive / UGuard Overland",
  skipToMain: "Aller au contenu principal",
  language: "Langue",
  english: "English",
  french: "Français"
};

export const dictionaries = { en, fr };
